import React, { Fragment } from 'react'
import { motion } from 'framer-motion'
import { CORRECT, WRONG } from '../../QuizConstants';
import Correct from './components/Correct';
import Wrong from './components/Wrong';
import { FormattedMessage } from 'react-intl';

const Question = ({
    status, question: { title, choices, wrong_response, instruction, success_response  }, mobile,
    final, finishQuiz, selectChoice, selectedChoices,
    submitAnswers, validated, nextQuestion, answerAgain 
}) => {
    const circle = {
        default: {
            fill: "none",
            stroke: "#00B5AC",
            strokeWidth: "2",
            strokeDashoffset: 0
        },
        checked: {
            fill: "#00B5AC",
            stroke: "none",
            strokeWidth: "2",
            strokeDashoffset: 0
        }
    }
    const check = {
        hidden: {
            pathLength: 0,
        },
        visible: {
            pathLength: 1,
        }
    }
    const animate = {
        default: {
            scale: 1
        },
        checked: {
            scale: [1.2, 1]
        }
    }
    if (status === CORRECT) {
        return (
            <Correct text={success_response} motion={motion} mobile={mobile} final={final} finishQuiz={finishQuiz} nextQuestion={nextQuestion} />
        )
    } else if (status === WRONG) {
        return <Wrong instruction={instruction} text={wrong_response} mobile={mobile} answerAgain={answerAgain} />
    } else {
        return (
            <Fragment>
                <motion.div
                    className="question__animator"
                    initial={{ opacity: 0 }}
                    animate={{ y: [50, 0], opacity: [0, 1] }}
                    transition={{ duration: .3, type: "spring", easing: "EaseInOut" }}
                >
                    <motion.p className="curtain" animate={{ x: [-1000, 1000] }} />
                    <div className="question">
                        <div className="question__header">
                            <p>{title}</p>
                            {
                                final ?
                                <FormattedMessage id="question.two.correct" defaultMessage="Choose two correct answers from below.">
                                    {
                                        text => 
                                        <p>{text}</p>
                                    }
                                </FormattedMessage>
                                :
                                <FormattedMessage id="question.one.correct" defaultMessage="Choose the correct answer from below.">
                                    {
                                        text => 
                                        <p>{text}</p>
                                    }
                                </FormattedMessage>
                            }
                        </div>
                        <ul className="question__choices">
                            {
                                choices.map((choice, key) => {
                                    const isChecked = selectedChoices.includes(key);
                                    return (
                                        <li className={isChecked ? 'active' : ''}>
                                            <label className="checkbox">
                                                <input checked={isChecked} type="checkbox" value={key} onChange={() => selectChoice(key)} />
                                                <span className="check">
                                                    <motion.svg animate={isChecked ? animate.checked : animate.default} width="42" height="42" viewBox="-2 -2 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <motion.circle initial={{ strokeDasharray: 1000, strokeDashoffset: 1000, fill: "none", stroke: "#00B5AC", strokeWidth: "2" }} animate={isChecked ? circle.checked : circle.default} cx="20" cy="20" r="20" />
                                                        <motion.path
                                                            variants={check}
                                                            initial="hidden"
                                                            animate={isChecked ? "visible" : "hidden"}
                                                            transition={{
                                                                default: { duration: .6, ease: "easeInOut" },
                                                                fill: { duration: .6, ease: [1, 0, 0.8, 1] }
                                                            }}
                                                            stroke="#FFF"
                                                            strokeWidth="2"
                                                            d="M12,20l6,6l11-11"
                                                        />
                                                    </motion.svg>
                                                </span>
                                                {choice.text}
                                            </label>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </motion.div>
                {
                    !mobile &&
                    <div className="question__footer">
                        <FormattedMessage id="question.button.check" defaultMessage="Check answer">
                            {
                                label => 
                                <button onClick={submitAnswers} className="btn btn--primary" type="button" disabled={!validated}><span className="label">{label}</span></button>
                            }
                        </FormattedMessage>
                    </div>
                }
            </Fragment>
        )
    }
}

Question.propTypes = {

}

export default Question
